<!-- 恢复暂存订单提示 -->
<template>
  <div v-if="isShow" class="restore-order-alert">
    <el-alert
      type="warning" 
      show-icon 
      class="restore-order-alert__alert"
      @close="handleClose"
    >
      <template slot="title">
        您上一次在线计价未完成订单已自动保存，如需要继续下单，请点击
        <BaseLink @click.native="handleClick">
          立即恢复
        </BaseLink>
      </template>
    </el-alert>
  </div>
</template>

<script>
// import { isSmtSite } from '@@/utils/is'
// import { targetSelfWindow } from '@@/utils/triggerParent'
import { getPcbaRestoreOrder } from '@@/api/pcba'

export default {
  data() {
    return {
      isShow: false,
      quoteId: ''
    }
  },
  created() {
    const { id } = this.$route.query
    if (!id) {
      this.getRestoreOrder()
    } else {
      this.isShow = false
    }
  },
  methods: {
    getRestoreOrder() {
      getPcbaRestoreOrder()
        .then(res => {
          const result = (res || {}).result
          if (result > 0) {
            this.quoteId = result
            this.isShow = true
          } else {
            this.isShow = false
          }
        })
    },
    handleClick() {
      this.handleClose()
      this.$emit('restore', this.quoteId)

      // const path = this.$route.path
      // const query = { id: this.quoteId }
      // if (isSmtSite) {
      //   this.$router.push({ path, query })
      //   window.location.reload()
      // } else {
      //   targetSelfWindow({ path, query })
      // }
    },
    handleClose() {
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.restore-order-alert {
  margin-bottom: 10px;
  width: 100%;
  flex-shrink: 0;
  .restore-order-alert__alert {
    background-color: $--tips-background-color;
  }
  .restore-order-alert__btn {
    padding: 0;
    color: $--form-color-base;
  }
}
</style>